import request from '@/utils/request'
const BASE_URL = '/pdd/orders'

export default {
  getBySn(orderSn, mallId = null) {
    var sys_type = localStorage.getItem("sys_type");
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = {};
    if (mallId) headers['mallid'] = mallId;

    return request({
      url: BASE_URL + '/' + sys_type + '/' + orderSn,
      method: 'get',
      headers: headers
    })
  },
  decrypt(orderSns, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var webPaTi, pageCode = "";
    webPaTi = localStorage.getItem("pati");
    pageCode = localStorage.getItem("pageCode");
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/decrypt',
      method: 'post',
      data: { orderSns, webPaTi: webPaTi, pageCode: pageCode },
      headers: headers
    })
  },
  fetchOrder(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var webPaTi, pageCode = "";
    webPaTi = localStorage.getItem("pati");
    pageCode = localStorage.getItem("pageCode");
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/fetch',
      // url: BASE_URL + '/fetchv2',
      method: 'post',
      data: { ...data, webPaTi: webPaTi, pageCode: pageCode },
      headers: headers
    })
  },
  fetchState(mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/fetch',
      method: 'get',
      headers: headers
    })
  },
  getCountInfo(mallId = null) {
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/countinfo',
      method: 'get',
      headers: headers
    })
  },
  getOrders(params, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'get',
      params,
      headers: headers
    })
  },
  getManualCountInfo(mallId = null) {
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/manualcountinfo',
      method: 'get',
      headers: headers
    })
  },
  getManual(params, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/manual',
      method: 'get',
      params,
      headers: headers
    })
  },
  postManual(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/manual',
      method: 'post',
      data,
      headers: headers
    })
  },
  putManual(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/manual',
      method: 'put',
      data,
      headers: headers
    })
  },
  delManual(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/manual',
      method: 'delete',
      data,
      headers: headers
    })
  },
  postWaybillCode(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/waybillcode',
      method: 'post',
      data,
      headers: headers
    })
  },
  test(data, mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    var headers = { 'UnCheck': 'uncheck' };
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/test',
      method: 'post',
      data,
      headers: headers
    })
  },
}